import { render, staticRenderFns } from "./SystemAdministratorDetails.vue?vue&type=template&id=cf594bf0"
import script from "./SystemAdministratorDetails.vue?vue&type=script&lang=js"
export * from "./SystemAdministratorDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports